<template>
  <div class="Join">
    <banner></banner>
    <wechat></wechat>
    <div class="Jc content">
      <!-- 团队信息 -->
      <div class="team">
        <div class="title">团队信息</div>
        <div class="headTitle">团长</div>
        <div class="head">
          <span>
            <img :src="groupInfo.wechat_avatar" />
          </span>
          <p>
            {{ groupInfo.wechat_nickname }}
          </p>
        </div>
        <div class="btn" @click="getActivityStatus">加入队伍</div>
      </div>
      <!-- 活动规则 -->
      <rule></rule>
      <gamme
        v-if="showGame"
        :game="game"
        :type="0"
        :groupInfo="groupInfo"
        @hideGmae="hideGmae"
        @confirm="confirmGame"
      ></gamme>
    </div>
  </div>
</template>

<script>
import banner from "./components/banner.vue";
import Rule from "./components/rule.vue";
import gamme from "./components/game.vue";
import Wechat from "./components/wechat.vue";
export default {
  components: { banner, Rule, gamme, Wechat },
  name: "Join",
  data: function () {
    return {
      ifJoin: false,
      showGame: false,
      groupInfo: [],
      game: "",
    };
  },
  methods: {
    hideGmae() {
      this.showGame = false;
    },
    confirmGame(val) {
      if (val) {
        // 加入队伍
        // 判断队伍人数
        if (this.groupInfo.teams_number < 4) {
          this.joinGroup();
        } else {
          this.$toast("队伍人数已满，提交失败");
        }
      }
    },
    // 获取主游戏id
    getPappId() {
      console.log("获取游戏接口");
      let data = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.getPappId,
        params: data,
      }).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.game = res.data.data;
          this.game.forEach((item, index) => {
            this.game[index].papp_name = item.papp_name.replace(/\[.*\]/g, "");
          });
        }
      });
    },
    // 获取用户团队信息接口
    getUserGroupInfo(msg) {
      let data = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.getUserGroupInfo,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.length > 0) {
              this.$router.push({
                name: "Team",
                params: {
                  teamID: res.data.data[0].group_id.replace("rebate:", ""),
                },
              });
            } else {
              if (msg) {
                this.$toast(msg);
              }
            }
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 活动状态 开始/结束
    getActivityStatus() {
      let data = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.getActivityStatus,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.flag == true) {
              // 活动开启
              this.join();
            } else {
              // this.$toast("活动尚未开始");
              // 活动结束 增加登录态判断，若有团队，前往团队页面
              let userCookie = this.$xh.getCookieArray("_XH_U_CL");
              if (userCookie[0]) {
                // 已经登录，请求用户是否有团队接口
                // this.getGroupStatus(0);
                this.getUserGroupInfo(res.data.msg);
              } else {
                window.location.href =
                  "https://m.rastargame.com/dist/login?type=1&return=" +
                  encodeURIComponent(window.location.href);
              }
              // this.$toast(res.data.msg);
            }
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 队员加入队伍
    joinGroup() {
      let wxName = this.$xh.getCookie("_XH_REBATE_NICKNAME");
      let wxImg = this.$xh.getCookie("_XH_REBATE_HEADIMGURL");
      let data = {
        tm: Date.parse(new Date()),
        papp_id: this.groupInfo.papp_id, //主游戏id
        group_id: this.groupInfo.group_id, // 团队id
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      if (wxName != "" && wxImg != "") {
        data.wechat_avatar = wxImg; // 微信头像
        data.wechat_nickname = wxName; // 微信昵称
      }
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.v1.joinGroup,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            // 允许开团
            this.$toast("入团成功...");
            // 跳转开团页面
            setTimeout(() => {
              this.$router.push({
                name: "Team",
                params: {
                  teamID: res.data.data.group_id.replace("rebate:", ""),
                },
              });
            }, 1500);
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    join() {
      let userCookie = this.$xh.getCookieArray("_XH_U_CL");
      if (userCookie[0]) {
        // this.getValidatIsGroup();
        this.getGroupStatus(0);
      } else {
        window.location.href =
          "https://m.rastargame.com/dist/login?type=1&return=" +
          encodeURIComponent(window.location.href);
      }
    },
    // 是否符合开团条件
    getGroupStatus(type) {
      console.log("检查用户开团组队状态接口");
      // type 开团标识1 组队标识0
      let data = {
        tm: Date.parse(new Date()),
        role_type: type,
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.getGroupStatus,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            // flag	Boolean	用户开团组队状态标识 true: 允许开团或组队，false: 不允许开团或组队
            // role_type	String	角色类型标识 开团检查1 入团检查0
            // is_jump	Boolean	是否跳转到活动页 true: 跳转，false: 不跳转
            // "data": {
            //     "flag": false,  不允许开团或组队  入团0  跳转
            //     "role_type": "0",  入团
            //     "is_jump": true   跳转
            // }

            // "data": {
            //     "flag": true,   允许开团或组队   开团检查1  不跳转
            //     "role_type": "1",
            //     "is_jump": false
            // }

            // {
            //  "flag": false,  不允许开团或组队   开团检查1   不跳转
            //  "role_type": "1",
            //  "is_jump": false,
            // }
            if (res.data.data.flag == false && res.data.data.is_jump == true) {
              // 不允许开团
              this.$toast(
                "您已经获得本次返利活动开团资格，不可加入他人队伍，成为团长可获得更多福利，现为您跳转至开团页面..."
              );
              // 跳转开团页面
              setTimeout(() => {
                this.$router.push({
                  name: "OpenGroup",
                });
              }, 1500);
            } else {
              // 允许开团
              this.getValidatIsGroup();
            }
          } else if (res.data.code == 6002) {
            this.$toast(res.data.msg);
            // 跳转队伍页面
            setTimeout(() => {
              this.$router.push({
                name: "Team",
                params: {
                  teamID: res.data.data.replace("rebate:", ""),
                },
              });
            }, 1500);
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取团队信息
    getGroupInfo() {
      let data = {
        tm: Date.parse(new Date()),
        group_id: "rebate:" + this.$route.params.teamID,
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.getGroupInfo,
        params: data,
      }).then((res) => {
        if (res.data.code == 200) {
          this.groupInfo = res.data.data;
          this.groupInfo.wechat_nickname = unescape(
            res.data.data.wechat_nickname
          );
        } else if (res.data.code == 6001) {
          // 队伍不存在
          this.$router.push({
            name: "Err",
          });
        }
        console.log(res);
      });
    },
    // 判断用户是否有团队
    getValidatIsGroup() {
      let data = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.getValidatIsGroup,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            // flag 用户入团状态标识 true: 用户未组队，false: 用户已组队
            // group_id 如果用户没有团队则返回null, 用户入团则返回团队idrebate:146353432_185
            if (res.data.data.flag == true) {
              // 可以组团
              this.showGame = true;
            } else {
              // 已组队，前往团队页面
              this.$toast("您已完成组队，请勿重复参加");
              // 跳转开团页面
              setTimeout(() => {
                this.$router.push({
                  name: "Team",
                  params: {
                    teamID: res.data.data.group_id.replace("rebate:", ""),
                  },
                });
              }, 1500);
            }
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 微信授权 (无论用户是否同意授权，都不影响后续流程)
    wxAuthorization() {
      // 第一次进入页面需拉起微信授权
      if (!this.$xh.getCookie("firstVisit")) {
        this.$xh.setCookie("firstVisit", "true", 30, window.location.hostname);
      }
      let wxName = this.$xh.getCookie("_XH_REBATE_NICKNAME");
      let wxImg = this.$xh.getCookie("_XH_REBATE_HEADIMGURL");
      if (this.$xh.getCookie("firstVisit") == "true") {
        console.log("玩家第一次进入页面");
        if (!wxName && !wxImg) {
          // 跳微信授权
          console.log("跳微信授权");
          window.location.href =
            "https://pt-u.rastargame.com/common/WechatCommon/oauth/?type=wechat&redirect_url=" +
            window.location.href;
        }
        this.$xh.setCookie("firstVisit", "false", 30, window.location.hostname);
      }
      // else {
      // let userCookie = this.$xh.getCookieArray("_XH_U_CL");
      //   if (userCookie[0]) {
      //     console.log("已登陆逻辑");
      //   } else {
      //     window.location.href =
      //       "https://m.rastargame.com/dist/login?type=1&return=" +
      //       encodeURIComponent(window.location.href);
      //   }
      // }
    },
  },
  mounted() {
    if (this.$xh.isWeChat()) {
      if (this.$xh.getCookie("_XH_COMMON_WECHAT")) {
        this.$xh.setCookie(
          "_XH_REBATE_NICKNAME",
          JSON.parse(unescape(this.$xh.getCookie("_XH_COMMON_WECHAT")))
            .nickname,
          30,
          window.location.hostname
        );
        this.$xh.setCookie(
          "_XH_REBATE_HEADIMGURL",
          JSON.parse(unescape(this.$xh.getCookie("_XH_COMMON_WECHAT")))
            .headimgurl,
          30,
          window.location.hostname
        );
      }
      this.wxAuthorization();
      this.getGroupInfo();
      this.getPappId();
      let userCookie = this.$xh.getCookieArray("_XH_U_CL");
      if (userCookie[0]) {
        this.getUserGroupInfo();
      }
    }
  },
};
</script>

<style scoped lang="scss" src="@/sass/join.scss"></style>
